import type { AxCursorType } from "../interop/types";
import { useBusEmitterListener } from "../bridge";

const setCursorEvent = Symbol("bridge:setCursor");
export const {
  emitter: setCursor,
  listener: onSetCursor,
} = useBusEmitterListener<{ cursor: AxCursorType; cursorName: string | undefined }>(setCursorEvent);

const focusCanvasEvent = Symbol("bridge:focusCanvas");
export const {
  emitter: focusCanvas,
  listener: onFocusCanvas,
} = useBusEmitterListener(focusCanvasEvent);

const invalidateCanvasEvent = Symbol("bridge:invalidateCanvas");
export const {
  emitter: invalidateCanvas,
  listener: onInvalidateCanvas,
} = useBusEmitterListener(invalidateCanvasEvent);

const toastMessageEvent = Symbol("bridge:toastMessage");
export const {
  emitter: toastMessage,
  listener: onToastMessage,
} = useBusEmitterListener<{ title: string; description: string | undefined }>(toastMessageEvent);
